/**
 * Data layer for `native-reconciliation-link-conversions-to-stripe-bank-deposits`. Thin typed fetch wrappers over /api/v1/native-reconciliation-link-conversions-to-stripe-bank-deposits.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface NativeReconciliationLinkConversionsToStripeBankDepositsRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListNativeReconciliationLinkConversionsToStripeBankDepositsResponse {
	count: number;
	items: NativeReconciliationLinkConversionsToStripeBankDepositsRow[];
}

export interface CreateNativeReconciliationLinkConversionsToStripeBankDepositsBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/native-reconciliation-link-conversions-to-stripe-bank-deposits";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListNativeReconciliationLinkConversionsToStripeBankDepositsResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListNativeReconciliationLinkConversionsToStripeBankDepositsResponse>(res);
}

export async function create(body: CreateNativeReconciliationLinkConversionsToStripeBankDepositsBody): Promise<NativeReconciliationLinkConversionsToStripeBankDepositsRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<NativeReconciliationLinkConversionsToStripeBankDepositsRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const nativeReconciliationLinkConversionsToStripeBankDepositsQueryKeys = {
	all: ["native-reconciliation-link-conversions-to-stripe-bank-deposits"] as const,
	list: () => [...nativeReconciliationLinkConversionsToStripeBankDepositsQueryKeys.all] as const,
	detail: (id: string) => [...nativeReconciliationLinkConversionsToStripeBankDepositsQueryKeys.all, id] as const,
};
